import styled, { css } from 'styled-components';
import { PaginationVariantEnum } from './types';
import { FlexCenterAligned } from '../../../styled/common';
import { ArrowDirection } from '../../../icons/Arrow';
import { tagStyles } from '../Typography/styles';

export const PaginationContainer = styled(FlexCenterAligned)<{
  $isPashaLanding?: boolean;
  $variant: PaginationVariantEnum;
}>`
  gap: ${({ $variant }) =>
    $variant === PaginationVariantEnum.pasha ? '12px' : '5px'};
  color: #fff;
  margin-top: ${({ $isPashaLanding }) => ($isPashaLanding ? '30px' : '0')};
`;

const pashaPageStyles = css<{ $isActive?: boolean }>`
  width: 28px;
  height: 28px;
  font-size: 14px;
  border: none;
  background: ${({ $isActive }) =>
    $isActive ? 'rgba(38, 40, 43, 0.8)' : 'transparent'};
  color: ${({ $isActive }) =>
    $isActive ? '#fff' : 'rgba(255, 255, 255, 0.8)'};
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    color: #fff;
  }

  &:disabled {
    color: #555;
    cursor: default;
  }
`;

const lightPageStyles = css<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive
        ? theme.colors.systemColors.blue
        : theme.colors.background.tertiary};
  background-color: ${({ theme, $isActive }) =>
    $isActive
      ? theme.colors.systemColors.blue
      : theme.colors.background.tertiary};
  transition: color 0.3s ease-in-out;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.background.primary : theme.colors.text.secondary};
  ${tagStyles.body_1};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  user-select: none;

  @media (hover: hover) {
    &:hover {
      ${({ $isActive, theme }) =>
        !$isActive &&
        css`
          color: ${theme.colors.systemColors.blue};
        `}
    }
  }
`;

export const buttonStyles = {
  [PaginationVariantEnum.pasha]: pashaPageStyles,
  [PaginationVariantEnum.defaultLight]: lightPageStyles
};

export const Page = styled.button<{
  $isActive?: boolean;
  $variant: PaginationVariantEnum;
}>`
  ${({ $variant }) => buttonStyles[$variant]};
`;

export const Ellipsis = styled.span<{
  $variant: PaginationVariantEnum;
}>`
  width: ${({ $variant }) =>
    $variant === PaginationVariantEnum.pasha ? '28px' : '35px'};
  text-align: center;
  cursor: default;
  color: ${({ $variant, theme }) =>
    $variant === PaginationVariantEnum.pasha
      ? 'rgba(255, 255, 255, 0.8)'
      : theme.colors.text.secondary};
`;

export const PaginationArrow = styled.button<{
  disabled: boolean;
  $direction: ArrowDirection;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
  transform: ${({ $direction }) =>
    $direction === ArrowDirection.right ? 'none' : 'rotate(180deg)'};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: opacity 0.2s ease;

  @media (hover: hover) {
    ${({ disabled, theme }) =>
      !disabled &&
      `
        &:hover svg path {
          fill: ${theme.colors.systemColors.blue};
        }
      `}
  }
`;
